import React, { Component } from "react";
import request from "../../lib/requester";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";

import { Link } from "react-router-dom";

import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import axios from "axios";
import Autocomplete from "../../component/autocomplete";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      fileContainer: [],
      loading: false,
      lovClaim: [],
      bupotContainer: [
        {
          claim_id: "",
          claim_number: "",
          principal: "",
          username: "",
          sendto: "",
          kwitansino: "",
          filename: "",
          fullurl: "",
        },
      ],
      documentContainer: [
        // { claim_id: "", index:"", filename: "", fullurl: "" },
      ],
      success: "",
      error: [],
      createdby: "",
    };
    this.onChangeAutocomplete = this.onChangeAutocomplete.bind(this);
  }

  componentDidMount = () => {
    this.state.fileContainer = [];
    this.state.loading = false;
    this.state.lovClaim = [];
    this.state.bupotContainer = [
      {
        claim_id: "",
        claim_number: "",
        principal: "",
        username: "",
        sendto: "",
        kwitansino: "",
        filename: "",
        fullurl: "",
      },
    ];
    this.state.documentContainer = [
      // { claim_id: "", index:"", filename: "", fullurl: "" },
    ];
    this.state.success = "";
    this.state.error = [];
    this.onChangeAutocomplete = this.onChangeAutocomplete.bind(this);
  };

  handleUpload = (e) => {
    let currentindex = e.target.attributes.getNamedItem("currentIndex").value;
    let currentclaimid = e.target.attributes.getNamedItem("currentclaimid")
      .value;
    let currentnumber = e.target.attributes.getNamedItem("currentnumber").value;

    let currentprincipal =
      e.target.attributes.getNamedItem("currentprincipal").value;
    let currentusername =
      e.target.attributes.getNamedItem("currentusername").value;
    let currentsendto =
      e.target.attributes.getNamedItem("currentsendto").value;
    let currentkwitansino =
      e.target.attributes.getNamedItem("currentkwitansino").value;

    if (currentclaimid.length > 0) {
      if (e.target.files.length === 0) {
        return false;
      }
      for (var i = 0; i < e.target.files.length; i++) {
        // let files = e.target.files[i];
        let files = e.target.files[0];

        // validation
        let filename = files.name;
        var fileExt = filename.split(".").pop();

        var allowedFile = [
          "jpg",
          "png",
          "jpeg",
          "gif",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "csv",
          "pdf",
        ];
        if (allowedFile.indexOf(fileExt) < 0) {
          this.setState({ error: ["File extension not allowed"] });
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          return false;
        }

        const data = new FormData();
        data.append("myFile", files, files.name);
        this.setState({ loading: true });
        request.postnobodyTraces("/api/traces/v1/general/upload-file", data, {
          success: function (response) {
            let data = response.data;
            //   console.log(data);
            // this.state.fileContainer.push({
            //   filename: data.filename, // this.state.productID
            //   fullurl: data.fullurl, // this.state.productDESC
            // });

            // hapus pada index jika sebelum nya sudah pernah diinput
            // if (this.state.bupotContainer.length <= 1) {
            //   this.state.bupotContainer[0].claim_id = currentclaimid;
            //   this.state.bupotContainer[0].claim_number = currentnumber;
            //   this.state.bupotContainer[0].filename = data.filename; // this.state.productID
            //   this.state.bupotContainer[0].fullurl = data.fullurl; // this.state.productDESC
            // } else {
            //   this.state.bupotContainer.push({
            //     claim_id: currentclaimid,
            //     claim_number: currentnumber,
            //     filename: data.filename, // this.state.productID
            //     fullurl: data.fullurl, // this.state.productDESC
            //   });
            // }

            this.state.bupotContainer[currentindex].claim_id = currentclaimid;
            this.state.bupotContainer[
              currentindex
            ].claim_number = currentnumber;


            this.state.bupotContainer[currentindex].principal =
              currentprincipal;

            this.state.bupotContainer[currentindex].username =
              currentusername;

            this.state.bupotContainer[currentindex].sendto = currentsendto;
            this.state.bupotContainer[currentindex].kwitansino =
              currentkwitansino;

            this.state.bupotContainer[currentindex].filename = data.filename; // this.state.productID
            this.state.bupotContainer[currentindex].fullurl = data.fullurl; // this.state.productDESC

            //   this.setState({ fileContainer: data, loading: false });
            // console.log(this.state.fileContainer);
            this.setState({ loading: false });
          }.bind(this),
          error: function (e) {
            this.setState({ loading: false });
          },
        });
      }
    } else {
      alert("please select claim number first.");
      return false;
    }
    // console.log(this.state.fileContainer);
  };

  removeFileBupot = () => {
    this.setState({ bupotContainer: {} });
  };

  // renderFileBupot = (indexa) => {
  //   return this.state.fileContainer.map((item, index) => (

  //     <div key={index}>
  //       <Link to={{ pathname: item.fullurl }} target="_blank">
  //         {item.filename}
  //       </Link>
  //     </div>

  //   ));
  // };

  renderFileBupot = (indexa) => {
    // return this.state.fileContainer.map((item, index) => (
    //   <div key={1}>
    //     <Link to={{ pathname: item.fullurl }} target="_blank">
    //       {item.filename}
    //     </Link>
    //   </div>
    // ));

    console.log("index:" & indexa);
  };

  onSelectClaim = (item, index) => {


    this.setState({ loading: true });

    let url = "/api/infostep/v1/general/get-username";
    let param = {
      user_id: item.created_by,
    };

    let { bupotContainer } = this.state;

    request.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        // console.log(data.username);
        // data.map((item, index) => {
        //   createdbyname = item.username;
        // });
        bupotContainer[index].sendto = data.username;
        this.setState({
          createdby: data.username,
          loading: false
        });
        window.scrollTo(0, 0);
        let app = this;
        window.setTimeout(() => {
          // app.props.history.push('/admin/claim/upload')
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });

    // console.log(this.state.createdby);

    bupotContainer[index].claim_id = item.value;
    bupotContainer[index].claim_number = item.text;
    bupotContainer[index].principal = item.principal;
    bupotContainer[index].username = this.state.user.username;
    // bupotContainer[index].sendto = this.state.createdby;
    bupotContainer[index].kwitansino = item.kwitansino;

    this.setState(bupotContainer);
    console.log(this.state.bupotContainer);
  };

  onChangeAutocomplete = (description) => {
    let container = [];
    let app = this;
    let param = {
      claimnumber: description,
    };

    let containerPrincipal = []
    this.state.user.principal_group.forEach((item, index) => {
      containerPrincipal.push(item.principal_code)
    })

    return new Promise((resolve) => {
      let url = "/api/traces/v1/claim/list-claim-v2";
      let param = {
        claimnumber: description,
        org_id: this.state.user.org_id,
        principal_group: containerPrincipal
      };

      request.postTraces(url, param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.claim_number;
            item.value = item.claim_id;
            item.principal = item.principal;
            item.username = this.state.user.username;
            item.created_by = item.created_by;
            item.kwitansino = item.kwitansino;
            return item;
          });
          resolve(container);
        }.bind(this),
        error: function (e) {
          resolve([]);
        }.bind(this),
      });
    });
  };

  renderClaim = () => {
    // console.log(this.state.fileContainer);
    // if (this.state.fileContainer && this.state.fileContainer.filename) {
    return this.state.bupotContainer.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-3">
          <Autocomplete
            onchange={this.onChangeAutocomplete.bind(this)}
            currentvalue={item.claim_number}
            currentIndex={index}
            onselect={this.onSelectClaim.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="file"
            id="files"
            name="files"
            // documentContainer
            className="form-control"
            currentIndex={index}
            currentclaimid={item.claim_id}
            currentnumber={item.claim_number}
            currentprincipal={item.principal}
            currentusername={item.username}
            currentsendto={item.sendto}
            currentkwitansino={item.kwitansino}
            onChange={this.handleUpload.bind(this)}
            multiple={false}
          />
        </div>
        <div>
          <button
            id="addclaim"
            type="button"
            onClick={this.replicateClaim.bind(this)}
            className="btn btn-success"
          >
            +
          </button>{" "}
          &nbsp;
          <button
            id="removeclaim"
            type="button"
            onClick={() => {
              this.removeClaim(index);
            }}
            className="btn btn-danger"
          >
            -
          </button>
        </div>

        <div className="col-md-4">
          <div key={index}>
            <Link to={{ pathname: item.fullurl }} target="_blank">
              {item.filename}
            </Link>
          </div>

          {/* {this.state.bupotContainer.map((item, index) => (
            <div key={index}>
              <Link to={{ pathname: item.fullurl }} target="_blank">
                {item.filename}
              </Link>
            </div>
          ))} */}

          {/* {this.state.fileContainer
            .filter((item) => item.claimindex == index)
            .map((item, index2) => (
              <div key={index2}>
                <Link to={{ pathname: item.fullurl }} target="_blank">
                  {item.filename}
                </Link>
              </div>
            ))} */}
        </div>
      </div>
    ));
    // }
  };

  replicateClaim = () => {
    if (this.state.bupotContainer.length >= 10) {
      alert("You can't submit more than 10 claim at the same time");
      return false;
    } else {
      let { bupotContainer } = this.state;
      bupotContainer.push({
        claim_id: "",
        claim_number: "",
        principal: "",
        username: "",
        sendto: "",
        kwitansino: "",
        filename: "",
        fullurl: "",



      });
      this.setState(bupotContainer);
    }
  };

  removeClaim = (index) => {
    if (this.state.bupotContainer.length < 2) {
      alert("You must select at least 1 claim");
      return false;
    } else {
      let { bupotContainer } = this.state;
      bupotContainer.splice(index, 1);
      this.setState(bupotContainer);
    }

    // console.log(this.state.bupotContainer);

    // let { bupotContainer } = this.state;
    // bupotContainer.splice(index, 1);
    // this.setState(bupotContainer);
    // console.log(bupotContainer);
    // this.renderClaim();
  };

  handleSubmit = () => {
    let url = "/api/traces/v1/claim/multiupdate-ebupot";
    let { id } = this.props.match.params;
    let container = [];

    // let container = this.state.fileContainer.map((item, index) => {
    //   item.filename = item.filename;
    //   item.fullurl = item.fullurl;
    //   item.claim_id = item.claim_id;
    //   return item;
    // });

    this.state.bupotContainer.forEach((item, index) => {
      container.push({
        filename: item.filename,
        filepath: item.fullurl,
        claim_id: item.claim_id,
        claim_number: item.claim_number,
        principal: item.principal,
        username: item.username,
        sendto: item.sendto,
        kwitansino: item.kwitansino,
      });
    });

    let param = {
      fileContainer: container,
      user_name: this.state.user.username,
      source: "arman",
      menu: "claim",
      function: "multiebupot",
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        this.setState({ loading: false, success: "File has been saved" });
        window.scrollTo(0, 0);
        let app = this;
        window.setTimeout(() => {
          window.location.reload();
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false, error: ["Failed to upload"] });
        window.setTimeout(() => {
          // app.props.history.push("/admin/claim/MultiUploadBukpot");
          let app = this;
          window.location.reload();
        }, 2000);
      }.bind(this),
    });
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          {this.state.success}
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">Multiupload E-bupot</div>
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <div className="row">
                      <div className="col-md-12">
                        {/* <h5>Claim Number</h5> */}
                        {/* <label
                          htmlFor="inputEmail3"
                          className="col-sm-1 col-form-label"
                        ></label> */}
                        <label
                          htmlFor="inputEmail3"
                          className="col-sm-3 col-form-label"
                        >
                          Claim Number
                        </label>
                        <label
                          htmlFor="inputEmail3"
                          className="col-sm-2 col-form-label"
                        >
                          E-Bupot
                        </label>

                        {this.renderClaim()}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <button
                        type="button"
                        className="btn btn-info"
                        onClick={this.handleSubmit.bind(this)}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Summary;
